export class SubscriptionCompare {
  readonly currentNextPaymentAt: Date
  readonly targetPaymentAt: Date
  readonly targetPaymentTrialPrice: number
  readonly currentPricePerDay: number
  readonly currentRemainingDays: number
  readonly targetRemainingDays: number
  readonly targetPricePerDay: number
  readonly descriptionHtml: string

  constructor(data: any) {
    this.currentNextPaymentAt = new Date(data.currentNextPaymentAt)
    this.targetPaymentAt = new Date(data.targetPaymentAt)
    this.targetPaymentTrialPrice = data.targetPaymentTrialPrice
    this.currentPricePerDay = data.currentPricePerDay
    this.currentRemainingDays = data.currentRemainingDays
    this.targetRemainingDays = data.targetRemainingDays
    this.targetPricePerDay = data.targetPricePerDay
    this.descriptionHtml = data.descriptionHtml
  }
}

export default class PremiumService {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly imageUrl: string
  readonly price: number
  readonly cutRate: number
  readonly purchaseType: string
  readonly trialDays: number
  readonly trialEndDate: number
  readonly trialFlag: number
  readonly trialPrice: number
  readonly startDate: string
  readonly subscriptionCompare: SubscriptionCompare
  readonly membershipFee: number

  constructor(data: any) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.imageUrl = data.imageUrl
    this.price = data.price
    this.cutRate = data.cutRate
    this.purchaseType = data.purchaseType
    this.trialDays = data.trialDays
    this.trialEndDate = data.trialEndDate
    this.trialFlag = data.trialFlag
    this.trialPrice = data.trialPrice
    this.startDate = data.startDate
    this.membershipFee = data.membershipFee
    this.subscriptionCompare = new SubscriptionCompare(data.subscriptionCompare)
  }
}
